import { render } from "./inpatient_nav.vue?vue&type=template&id=58212b9b&scoped=true"
import script from "./inpatient_nav.vue?vue&type=script&lang=js"
export * from "./inpatient_nav.vue?vue&type=script&lang=js"

import "./inpatient_nav.vue?vue&type=style&index=0&id=58212b9b&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58212b9b"]])

export default __exports__